export default __webpack_public_path__ + "static/media/visa.44f30929.png";